import appCompanies from "../../views/appFleet/companies.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "companies";
  const params = ["page", "limit", "city", "sort"];

  $stateProvider.state("companies", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCompanies,
      },
    },
    reloadOnSearch: false,
    data: { title: "Companies" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/companies/companies.urls.js